import React from "react";

export const IconTimer = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17.8"
            height="17.801"
            viewBox="0 0 17.8 17.801"
        >
            <g id="clock" transform="translate(-1.6 -1.1)">
                <circle
                    id="Ellipse_12"
                    data-name="Ellipse 12"
                    cx="8"
                    cy="8"
                    r="8"
                    transform="translate(2.5 2)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <path
                    id="Path_358"
                    data-name="Path 358"
                    d="M12,6v6l4,2"
                    transform="translate(-2.5 -1.333)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
